import React, { FC } from 'react';
import classNames from 'classnames';
import Comma from '../../../components/Comma';
import { Image } from '../../../components/Image';
import styles from './TechInnovation.module.scss';
import { TechInnovationData } from '../type';

/**
 * 科技创新数据展示组件
 * 展示标题、左侧特性介绍列表，以及右侧展示大图
 */
const TechInnovation: FC<TechInnovationData> = (props) => {
  const { titleMain, titleVice, featureArr, img } = props;

  return (
    <div className={styles['tech-innovation']}>
      {/* 标题 */}
      <div className={classNames(styles['tech-innovation-title'])}>
        <span className={styles['tech-innovation-title-item']}>{titleMain}</span>
        {titleVice && (
          <span className={styles['comma-box']}>
            <Comma />
          </span>
        )}
        <span className={styles['tech-innovation-title-item']}>{titleVice}</span>
      </div>

      <div className={styles['tech-innovation-content']}>
        {/* 左侧：特性介绍列表 */}
        <div className={styles['tech-innovation-feature-list']}>
          {featureArr.map((item, index) => (
            <div key={index} className={styles['tech-innovation-feature-item']}>
              <div className={classNames(styles['tech-innovation-feature-title'])}>{item.title}</div>
              {item.description.map((line, lineIndex) => (
                <div key={lineIndex} className={styles['tech-innovation-feature-desc']}>
                  {line}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* 右侧：展示大图 */}
        <div className={styles['tech-innovation-img-wrap']}>
          <Image src={img} layout="responsive" width={810} height={460} objectFit="cover" />
        </div>
      </div>
    </div>
  );
};

TechInnovation.displayName = 'TechInnovation';
export default TechInnovation;
